import { action } from 'satcheljs/lib/legacy';
import type { default as FolderStore, MailboxFolderTreeData } from '../store/schema/FolderStore';
import type { MailFolder } from 'owa-graph-schema';
import type DistinguishedFolderIdName from 'owa-service/lib/contract/DistinguishedFolderIdName';
import { ObservableMap } from 'mobx';
import type FolderId from 'owa-service/lib/contract/FolderId';
import FolderTreeLoadStateEnum from '../store/schema/FolderTreeLoadStateEnum';
import type FolderTreeData from '../store/schema/FolderTreeData';
import {
    ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID,
    PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID,
} from 'owa-folders-constants';

export let mockFolderStore: FolderStore = {
    folderTable: new ObservableMap(),
    mailboxFolderTreeData: new ObservableMap(),
};

let folderIdIncrementor = 0;
let folderNameToIdMap: { [key: string]: string };

export function getMockFolderStore() {
    return mockFolderStore;
}
export function getNextFolderId(): FolderId {
    return { Id: 'folderId' + (folderIdIncrementor++).toString(), ChangeKey: 'foo' };
}
export let addFolderToStore = function addFolderToStore(folder: MailFolder, isFavorite?: boolean) {
    mockFolderStore.folderTable.set(folder.id, folder);
    if (folder.parentFolderId) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2532 (34,9): Object is possibly 'undefined'.
        // @ts-expect-error
        mockFolderStore.folderTable.get(folder.parentFolderId).childFolderIds.push(folder.id);
    }

    if (folder.distinguishedFolderType) {
        folderNameToIdMap[folder.distinguishedFolderType] = folder.id;
    }
};

function addMailboxToStore(folder: MailFolder) {
    const primaryMailbox: FolderTreeData = {
        id: PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID,
        rootFolder: folder,
        loadingState: FolderTreeLoadStateEnum.Uninitialized,
    };
    const archiveMailbox: FolderTreeData = {
        id: ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (53,9): Type 'null' is not assignable to type 'MailFolder'.
        // @ts-expect-error
        rootFolder: null,
        loadingState: FolderTreeLoadStateEnum.Uninitialized,
    };

    // onemailview - this file is used only in test

    const loggedInUserFolderTreeTable = new ObservableMap<string, FolderTreeData>({
        [PRIMARY_FOLDER_ROOT_DISTINGUISHED_ID]: primaryMailbox,
        [ARCHIVE_FOLDER_ROOT_DISTINGUISHED_ID]: archiveMailbox,
    });

    mockFolderStore.mailboxFolderTreeData.set('loggedInUser', {
        folderTreeTable: loggedInUserFolderTreeTable,
        sharedFolderUserEmails: [],
    });
}

addFolderToStore = action('addFolderToStore-TestMethod')(addFolderToStore);

export function resetFolderState(): void {
    folderNameToIdMap = {};
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2352 (77,22): Conversion of type '{ displayName: string; FolderClass: string; id: string; parentFolderId: null; childFolderIds: never[]; distinguishedFolderType: string; UnreadCount: number; totalMessageCount: number; mailboxInfo: { ...; }; }' to type 'MailFolder' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
    // @ts-expect-error
    let rootFolder = <MailFolder>{
        displayName: 'Root folder',
        FolderClass: 'IPF.Note',
        id: 'msgfolderroot',
        parentFolderId: null,
        childFolderIds: [],
        distinguishedFolderType: 'msgfolderroot',
        UnreadCount: 0,
        totalMessageCount: 0,
        mailboxInfo: {
            type: 'UserMailbox',
            mailboxSmtpAddress: 'foo@microsoft.com',
            userIdentity: 'foo@microsoft.com',
        },
    };

    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2352 (96,30): Conversion of type '{ displayName: string; FolderClass: string; id: string; parentFolderId: string; childFolderIds: never[]; distinguishedFolderType: string; UnreadCount: number; totalMessageCount: number; mailboxInfo: { ...; }; }' to type 'MailFolder' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
    // @ts-expect-error
    let deletedItemsFolder = <MailFolder>{
        displayName: 'Deleted items',
        FolderClass: 'IPF.Note',
        id: 'deleteditems',
        parentFolderId: rootFolder.id,
        childFolderIds: [],
        distinguishedFolderType: 'deleteditems',
        UnreadCount: 5,
        totalMessageCount: 6,
        mailboxInfo: {
            type: 'UserMailbox',
            mailboxSmtpAddress: 'foo@microsoft.com',
            userIdentity: 'foo@microsoft.com',
        },
    };

    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2352 (115,17): Conversion of type '{ displayName: string; FolderClass: string; id: string; parentFolderId: string; childFolderIds: never[]; distinguishedFolderType: string; UnreadCount: number; totalMessageCount: number; mailboxInfo: { ...; }; }' to type 'MailFolder' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
    // @ts-expect-error
    let inbox = <MailFolder>{
        displayName: 'Inbox',
        FolderClass: 'IPF.Note',
        id: 'inbox',
        parentFolderId: rootFolder.id,
        childFolderIds: [],
        distinguishedFolderType: 'inbox',
        UnreadCount: 3,
        totalMessageCount: 7,
        mailboxInfo: {
            type: 'UserMailbox',
            mailboxSmtpAddress: 'foo@microsoft.com',
            userIdentity: 'foo@microsoft.com',
        },
    };

    mockFolderStore = {
        folderTable: new ObservableMap<string, MailFolder>(),
        mailboxFolderTreeData: new ObservableMap<string, MailboxFolderTreeData>(),
    };

    addMailboxToStore(rootFolder);
    addFolderToStore(rootFolder);
    addFolderToStore(deletedItemsFolder);
    addFolderToStore(inbox);
}

export function folderNameToId(distinguishedFolderId: DistinguishedFolderIdName): string {
    return folderNameToIdMap[distinguishedFolderId];
}

export function getDistinguishedFolder(
    distinguishedFolderId: DistinguishedFolderIdName
): MailFolder {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (152,5): Type 'MailFolder | undefined' is not assignable to type 'MailFolder'.
    // @ts-expect-error
    return mockFolderStore.folderTable.get(folderNameToId(distinguishedFolderId));
}

export function createAndAddFolderToStore(displayName: string, parentFolderId: string): string {
    const folderId = getNextFolderId();
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2352 (160,18): Conversion of type '{ id: string; displayName: string; parentFolderId: string; FolderClass: string; childFolderIds: never[]; mailboxInfo: { type: string; mailboxSmtpAddress: string; userIdentity: string; }; }' to type 'MailFolder' may be a mistake because neither type sufficiently overlaps with the other. If this was intentional, convert the expression to 'unknown' first.
    // @ts-expect-error
    let folder = <MailFolder>{
        id: folderId.Id,
        displayName: displayName,
        parentFolderId: parentFolderId,
        FolderClass: 'IPF.Note',
        childFolderIds: [],
        mailboxInfo: {
            type: 'UserMailbox',
            mailboxSmtpAddress: 'foo@microsoft.com',
            userIdentity: 'foo@microsoft.com',
        },
    };

    addFolderToStore(folder);

    return folderId.Id;
}
